import { ReportMetric, ReportMetricFormat } from './reportEnums';

const numberMetrics = new Set<ReportMetric>([
  ReportMetric.AdImpressionsNonStitched,
  ReportMetric.FilledImpressionsNonStitched,

  ReportMetric.IiqResolvedRequests,
  ReportMetric.IiqAdImpressions,
  ReportMetric.AdRequests,
  ReportMetric.AdImpressions,
  ReportMetric.AdUnitImpressions,
  ReportMetric.FilledImpressions,
  ReportMetric.DpAdRequests,
  ReportMetric.Bids,
  ReportMetric.WonBids,
  ReportMetric.LostBids,
  ReportMetric.InsertionRate,
  ReportMetric.ContentImpressions,
  ReportMetric.StichImpressions,
  ReportMetric.FilledImpressionsStitched,
  ReportMetric.AdImpressionsStitched,
  ReportMetric.ImmuVideoPlayed,
  ReportMetric.ContentRequest,
  ReportMetric.WonBidsCache,
  ReportMetric.FilledImpressionsCache,
  ReportMetric.AdImpressionsCache,
  ReportMetric.BidsLi,
  ReportMetric.WonBidsLi,
  ReportMetric.FilledImpressionsLi,
  ReportMetric.AdImpressionsLi,
  ReportMetric.Errors,
  ReportMetric.AdStart,
  ReportMetric.AdQuartile1,
  ReportMetric.AdMid,
  ReportMetric.AdQuartile3,
  ReportMetric.AdCompletion,
  ReportMetric.PubAdImpressions,
  ReportMetric.AdClicks,
  ReportMetric.View,
  ReportMetric.PubRpm,
  ReportMetric.AdImpressionsDvIqm,
  ReportMetric.BcFind,
  ReportMetric.BcStore,
  ReportMetric.BcUnlock,
  ReportMetric.BcUse,
  ReportMetric.IvtTotalEvents,
  ReportMetric.IvtInvalidTraffic,
  ReportMetric.IvtSofisticated,
  ReportMetric.IvtGeneral,
  ReportMetric.IvtValidTraffic,
  ReportMetric.WebVideoPageRequest,
  ReportMetric.Timeouts,
  ReportMetric.OutgoingFloor,
  ReportMetric.FloorEcpm,
]);

const percentageMetrics = new Set<ReportMetric>([
  ReportMetric.DpAdRequestRatio,
  ReportMetric.AdRequestsFilled,
  ReportMetric.RenderRate,
  ReportMetric.ResponseRate,
  ReportMetric.NetworkMarginPct,
  ReportMetric.MarginPct,
  ReportMetric.PublisherRevenueShare,
  ReportMetric.BidFillRatio,
  ReportMetric.WinRatio,
  ReportMetric.BidRatio,
  ReportMetric.LostRatio,
  ReportMetric.BundleRevenueShare,
  ReportMetric.NetworkRevenuePct,
  ReportMetric.RenderRateLi,
  ReportMetric.RenderRateStitched,
  ReportMetric.AdImpressionsStitchedPct,
  ReportMetric.PubRenderRate,
  ReportMetric.PublisherRevenueShareIo,
  ReportMetric.DpFillRatio,
  ReportMetric.ViewPct,
  ReportMetric.RevenuePct,
  ReportMetric.IvtInvalidTrafficPct,
  ReportMetric.IvtSofisticatedPct,
  ReportMetric.IvtGeneralPct,
  ReportMetric.IvtValidTrafficPct,
]);

const currencyMetrics = new Set<ReportMetric>([
  ReportMetric.Ecpm,
  ReportMetric.RevenueBids,
  ReportMetric.RevenueFill,
  ReportMetric.PreMpRevenue,

  ReportMetric.IiqRevenue,
  ReportMetric.Revenue,
  ReportMetric.NetRevenue,
  ReportMetric.GrossRevenue,
  ReportMetric.PubRevenue,
  ReportMetric.Profit,
  ReportMetric.Rpm,
  ReportMetric.Srpm,
  ReportMetric.PublisherNetworkCpm,
  ReportMetric.PublisherCpm,
  ReportMetric.BundleCpm,
  ReportMetric.NetworkSaasFee,
  ReportMetric.NetworkRevenue,
  ReportMetric.NetworkProfit,
  ReportMetric.RevenueCache,
  ReportMetric.PubRevenueCache,
  ReportMetric.RpmNet,
  ReportMetric.RevenueLi,
  ReportMetric.PubRevenueLi,
  ReportMetric.RpmLi,
  ReportMetric.RevenueStitched,
  ReportMetric.RpmStitched,
  ReportMetric.MpRevenue,
  ReportMetric.ClickCpm,
  ReportMetric.LrSegmentCost,
  ReportMetric.StitchCpmCost,
  ReportMetric.Rps,
  ReportMetric.PubGrossRevenue,
  ReportMetric.BidCpm,
  ReportMetric.FillCpm,
  ReportMetric.RpmFill,
]);

export function metricFormat(metric: ReportMetric) {
  if (numberMetrics.has(metric)) return ReportMetricFormat.Number;
  if (percentageMetrics.has(metric)) return ReportMetricFormat.Percentage;
  if (metric === ReportMetric.Ctr) return ReportMetricFormat.PercentagePlain;
  if (metric === ReportMetric.BidWinLostRatio) return ReportMetricFormat.Decimal;
  if (metric === ReportMetric.Day) return ReportMetricFormat.DateTime;
  if (metric === ReportMetric.BidfloorReq) return ReportMetricFormat.BidFloor;
  if (currencyMetrics.has(metric)) return ReportMetricFormat.Currency;
  return ReportMetricFormat.String;
}
